import React from 'react';
import { OneLogin } from 'components/SSO/Onelogin';

export function OneloginSSOPage() {
  return <OneLogin />;
}
